import { styled, TextField } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';
import FONTS from '../../../Constant/FONTS';

const TextFieldGrey = styled(TextField)({
  '.MuiOutlinedInput-root': {
    fontFamily: FONTS.MONT,
    backgroundColor: COLORS.surfaceAlt,
  },
});

export default TextFieldGrey;
